import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InputCustomerTenantDialog } from "./InputCustomerTenantDialog";
import { useRegisterTenantButton } from "./useRegisterTenantButton";
import { ConfirmDialog } from "./ConfirmDialog";

interface Props {
  onAfterRegister: () => void;
}

/**
 * お客様テナント追加ボタンのコンポーネントです。
 *
 * @returns お客様テナント追加ボタンのコンポーネント
 */
export const RegisterTenantButton = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const {
    inputDialogOpen,
    confirmDialogOpen,
    tenantFormData,
    onClick,
    onConfirm,
    onInputCancel,
    onRegister,
    onConfirmCancel,
  } = useRegisterTenantButton("", "", props.onAfterRegister);

  return (
    <>
      <Button variant="contained" onClick={onClick}>
        {t("admin.registerCustomerTenantButton")}
      </Button>

      {/* 入力ダイアログ */}
      <InputCustomerTenantDialog
        open={inputDialogOpen}
        formData={tenantFormData}
        id=""
        acceptButtonName={t("common.registerButton")}
        onConfirm={onConfirm}
        onCancel={onInputCancel}
        isEdit={false}
      />

      {/* 確認ダイアログ */}
      <ConfirmDialog
        open={confirmDialogOpen}
        title={t("admin.confirmRegisterCustomerTenant")}
        formData={tenantFormData}
        acceptButtonName={t("common.registerButton")}
        onRegister={onRegister}
        onCancel={onConfirmCancel}
      />
    </>
  );
};
